import { useState} from 'react'
import axios from 'axios'
import config from '../config'

const ChatInput = ({ user, otherUserId, clickedClothesId }) => {
    const [textArea, setTextArea] = useState("")
    const userId = user?.user_id

    const addMessage = async () => {
        const message = {
            timestamp: new Date().toISOString(),
            from_userId: userId,
            to_userId: otherUserId,
            clicked_clothesId: clickedClothesId,
            message: textArea
        }
        try {
            await axios.post(`${config.apiUrl}message`, 
                { 
                    data:message 
                },
                {
                    headers: {"token": localStorage.getItem("token")},
                }
                
            )
            setTextArea("")
        } catch (error) {
            console.log(error)
        }
    }


    return (
        <div className="chat-input">
            <textarea value={textArea} onChange={(e) => setTextArea(e.target.value)}/>
            <button className="secondary-button" onClick={addMessage}>Absenden</button>
        </div>
    )
}

export default ChatInput